import { ContactUs, CopyrightFooter } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'

class LegalDisclaimer extends Container<{}, {}> {
  state = {}

  mapAppStateToContainerState(appState: IAppState): {} {

    return this.state
  }

  render() {
    return (
      <section className="padding-top-lg">
        <div className="container" style={{ overflowX: 'hidden' }}>
          <div className="jumbotron animated fadeIn">
            <h1 className="hidden-xs">Legal Disclaimer</h1>
            <h3 className="visible-xs">Legal Disclaimer</h3>
          </div>
          <div className="margin-y animated fadeIn">
            <div className="panel">
              <div className="panel-body">
                <p>Foundation Financial Research LLC. All rights reserved. FOUNDATIONMARK is a registered trademark of Foundation

Financial Research LLC. Redistribution, reproduction and/or photocopying in whole or in part are prohibited without

written permission. Foundation Financial Research receives compensation in connection with licensing its indices to

third parties. Past performance of an index is not a guarantee of future results.

These materials have been prepared solely for informational purposes based upon information generally available to

the public from sources believed to be reliable. Data for FoundationMark Indices are calculated by Foundation Financial

Research based on disclosure in publicly available filings from the IRS of the individual constituents of the indices.

No content contained in these materials (including index data, model, software or other application or output

therefrom) or any part thereof (Content) may be modified, reverse-engineered, reproduced or distributed in any form

by any means, or stored in a database or retrieval system, without the prior written permission of Foundation Financial

                        Research LLC. </p><p>

                  Foundation Financial Research LLC is not an investment advisor, and Foundation Financial Research makes no

representation regarding the advisability of investing in any such investment fund or other investment vehicle.

The Content shall not be used for any unlawful or unauthorized purposes. Foundation Financial Research does not

guarantee the accuracy, completeness, timeliness or availability of the Content. Foundation Financial Research is not

responsible for any errors or omissions, regardless of the cause, for the results obtained from the use of the Content. </p><p>

                  THE CONTENT IS PROVIDED ON AN AS IS BASIS. FOUNDATION FINANCIAL RESEARCH DISCLAIMS ANY AND ALL

EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, ANY WARRANTIES OF MERCHANTABILITY OR

FITNESS FOR A PARTICULAR PURPOSE OR USE, FREEDOM FROM BUGS, SOFTWARE ERRORS OR DEFECTS, THAT THE

CONTENT'S FUNCTIONING WILL BE UNINTERRUPTED OR THAT THE CONTENT WILL OPERATE WITH ANY SOFTWARE OR

HARDWARE CONFIGURATION. In no event shall Foundation Financial Research be liable to any party for any direct,

indirect, incidental, exemplary, compensatory, punitive, special or consequential damages, costs, expenses, legal fees,

or losses (including, without limitation, lost income or lost profits and opportunity costs) in connection with any use of

the Content even if advised of the possibility of such damages.

Performance analyses, including ratings, are statements of opinion as of the date they are expressed and not

statements of fact.

Foundation Financial Research does not assume any obligation to update the Content following publication in any form

or format. The Content should not be relied on and is not a substitute for the skill, judgment and experience of the

user, its management, employees, advisors and/or clients when making investment and other business decisions.

Foundation Financial Research LLC does not act as a fiduciary or an investment advisor. While Foundation Financial

Research has obtained information from sources they believe to be reliable, Foundation Financial Research does not

perform an audit or undertake any duty of due diligence or independent verification of any information it receives.

About US Newsroom Contact US

PERFORMANCE DISCLOSURE

Charts and graphs are provided for illustrative purposes. Past performance is no guarantee of future results. These

charts and graphs may reflect hypothetical historical performance. All information presented prior to the launch date is

back-tested. Back-tested performance is not actual performance, but is hypothetical. The back-test calculations are

based on the same methodology that was in effect when the index was officially launched. Please refer to the

methodology paper for the Index, available at www.FoundationMark.com for more details about the index, including

the manner in which it is rebalanced, criteria for additions and deletions, as well as all index calculations.</p>

              </div>
            </div>
          </div>
        </div>

        <ContactUs />
        <CopyrightFooter />
      </section>
    )
  }
}

export {
  LegalDisclaimer
}



// WEBPACK FOOTER //
// ./src/app/containers/LegalDisclaimer/index.tsx